import { useState } from "react";
import { Menu, Newspaper } from "lucide-react";
import { Link } from "react-router-dom";

import { ShadcnButton } from "@components/items/display/ShadcnButton";
import WajeezLogo from "@components/items/common/WajeezLogo";
import { Sidebar } from "./Sidebar";
import { useLanguage } from "@modules/localizations/LanguageContext";
import { translate } from "@modules/localizations/translate";

export const navbarItems: {
  title: string;
  path: string;
  Icon: JSX.Element;
  isExternal: boolean;
}[] = [
  {
    title: translate("layout.blog"),
    path: "https://wajeez.com/blog",
    Icon: <Newspaper />,
    isExternal: true,
  },
  // { title: "من نحن", path: "" },
  // { title: "اتصل بنا", path: "" },
];

const Navbar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { language } = useLanguage();

  return (
    <>
      <nav className="sticky top-0 hidden h-[79px] w-full items-center justify-between bg-NAV_DARK bg-opacity-80 text-white sm:flex">
        <div className="flex items-center justify-start">
          <div className="flex w-[134px] items-center justify-center">
            <Link to={"/login"}>
              <WajeezLogo width={80} lang={language} />
            </Link>
          </div>
          <div className="flex w-[331px] items-center justify-between pl-[500px]">
            {navbarItems.map((item, index) => (
              <a key={index} href={item.path}>
                <ShadcnButton className="bg-transparent px-5 py-6 hover:bg-transparent dark:bg-transparent dark:hover:bg-transparent">
                  <div className="text-[18px] font-medium">{item.title}</div>
                </ShadcnButton>
              </a>
            ))}
          </div>
        </div>
        {/* <div className="flex justify-end items-center p-5 gap-2">
        <ShadcnButton className="px-5 py-6 bg-transparent hover:bg-white">
          <TranslatedText
            text={`layout.${"sign in"}`}
            className="text-[16px] font-medium text-primary"
          />
        </ShadcnButton>
        <ShadcnButton className="px-5 py-6">
          <TranslatedText
            text={`layout.${"subscribe"}`}
            className="text-[16px] font-medium text-white"
          />
        </ShadcnButton>
      </div> */}
      </nav>
      <nav className="sticky top-0 z-10 flex w-full items-center justify-between bg-[#2D2E35DD] pe-4 sm:hidden">
        <Link to={"/login"} className="block pt-2">
          <WajeezLogo width={80} lang={language} />
        </Link>
        <div
          className="text-white"
          onClick={() => {
            setIsSidebarOpen(true);
          }}
        >
          <Menu size={30} />
        </div>
      </nav>
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
      />
    </>
  );
};

export default Navbar;
